import { stringify } from "qs";

const appendSearch = (params: Record<string, string>) => {
  return stringify(params, { addQueryPrefix: true });
};

export function linkToScanCard(opts: {} = {}) {
  const search = { ...opts };

  return `/scan-card${appendSearch(search)}`;
}
